import { useAuth } from "../hooks/useAuth";

const F = "'DM Sans', system-ui, sans-serif";

export default function SessionWarning() {
  const { sessionWarning, extendSession, logout } = useAuth();

  if (!sessionWarning) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 500,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "#fff", borderRadius: "12px", padding: "2rem", maxWidth: "400px",
        width: "90%", textAlign: "center", boxShadow: "0 25px 50px -12px rgba(0,0,0,0.4)",
      }}>
        <div style={{ fontSize: "2.5rem", marginBottom: "0.75rem" }}>&#9888;&#65039;</div>
        <h2 style={{ fontSize: "1.25rem", fontWeight: "700", color: "#0f172a", fontFamily: F, marginBottom: "0.5rem" }}>
          Session Expiring
        </h2>
        <p style={{ fontSize: "0.875rem", color: "#64748b", fontFamily: F, marginBottom: "1.5rem" }}>
          Your session will expire in 2 minutes due to inactivity.
          Any unsaved changes may be lost.
        </p>
        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
          <button
            onClick={logout}
            style={{
              background: "#e2e8f0", color: "#334155", border: "none", borderRadius: "8px",
              padding: "0.625rem 1.25rem", fontSize: "0.875rem", fontWeight: "600",
              cursor: "pointer", fontFamily: F,
            }}
          >
            Sign Out
          </button>
          <button
            onClick={extendSession}
            style={{
              background: "#0369a1", color: "#fff", border: "none", borderRadius: "8px",
              padding: "0.625rem 1.25rem", fontSize: "0.875rem", fontWeight: "600",
              cursor: "pointer", fontFamily: F,
            }}
          >
            Stay Signed In
          </button>
        </div>
      </div>
    </div>
  );
}
